import { Component, OnInit } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
@Component({
	standalone: true,
	selector: 'app-loader',
	templateUrl: './loader.component.html',
	styleUrls: ['./loader.component.scss'],
	imports: [ProgressSpinnerModule],
})
export class LoaderComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
